import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core';
import ModalCustom from '../../common/modalCustom/modalCustom';

let useStyles = makeStyles(() => ({
    root: {
        width: 400,
        padding: '20px 10px',
        maxWidth: '95% ',
        textAlign: 'center',
        "@media(max-width : 500px)": {
            width: '95%'
        },
    },
    customButton: {
        backgroundColor: '#0B1742 !important',
        color: '#fff',
        margin: 'auto !important',
        minWidth: "162px !important",
        minHeight: "40px !important",
        marginTop: '10px !important',
    },
    images: {
        width: '100%'
    }
}))





const ModalNotif = ({ open, setOpen, handelClick }) => {

    let classes = useStyles();

    const handelBack = () => {
        setOpen((prev) => ({
            service: 'sejam',
            flag: false,
            message: ''
        }))
        setTimeout(() => {
            handelClick()
        }, 500);
    }

    return (

        <ModalCustom
            open={open?.flag}
            onClose={() => setOpen(prev => ({ ...prev, flag: false }))}
        >
            <div className={classes['root']}>
                <div>
                    <img src="/assets/images/Logo.png" alt="" className={classes['images']} />
                </div>
                <div>
                    <p>
                        {
                            open?.message
                        }
                    </p>
                </div>
                <div className={classes['gridBtns']}>
                    <Button
                        className={classes.customButton}
                        variant="contained"
                        style={{ color: 'white' }}
                        onClick={() => handelBack()}
                    >
                        فهمیدم
                    </Button>
                </div>

            </div>
        </ModalCustom>

    )
}


export default ModalNotif;